import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQwiklabsComponent } from './simple-icons-qwiklabs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQwiklabsComponent ],
    exports:      [ SimpleIconsQwiklabsComponent ],
    bootstrap:    []
})
export class SimpleIconsQwiklabsModule {}
